import { Pipe } from '@angular/core';
import { applyPrecision } from '../helpers/helpers';
var RoundPipe = (function () {
    function RoundPipe() {
    }
    RoundPipe.prototype.transform = function (num, precision) {
        if (precision === void 0) { precision = 0; }
        return applyPrecision(num, precision);
    };
    return RoundPipe;
}());
export { RoundPipe };
RoundPipe.decorators = [
    { type: Pipe, args: [{ name: 'round' },] },
];
/** @nocollapse */
RoundPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=round.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/math/round.js
// module id = 243
// module chunks = 4